import React, { Component } from 'react'
import connexion from '../../connexion'
import M from 'materialize-css'
import { Menu } from '@headlessui/react'
import RenderPage from './RenderPage'
import CKEditor from '../UI/CKEditor'
import IconPicker from '../UI/IconPicker'
import LangPills from '../UI/LangPills'
import Modal from '../UI/Modal'
import Loader from '../UI/Loader'
import tools from '../../tools'
import '../Core/Main.css'

class Pages extends Component {
	constructor(props) {
		super(props)
		this.state = {
			page: null,
			edit: false,
			section: null,
			update_cover: false,
			cover_warning: null,
			answerModal: null,
			open_modal: false,
			modal_msg: null,
			delete: false,
			duplicate: false,
			attempt_submit: false,
			contacts_open: false,
			form1: { //Image de couverture
				cover: null
			},
			form2: { //Section : icon, titre, contenu
				icon: null,
				prev: null,
				phone: '',
				email: '',
				website: '',
				localisation: '',
				facebook: '',
				instagram: '',
				translations: []
			},
			form3: { //services
				add_service: false,
				service: '',
				link: '',
				translations: []
			},
			navigation: [
				{ name: 'Rubriques', href: '/Rubriques', current: false },
				{ name: '...', href: '#', current: true },
			],
			error: this._initErrors(),
			success: this._initSuccess()
		}
		this.section_length_max = 60
		this.length_max = 40
	}

	componentDidMount() {
		this.loadPage()
		if (this.props.features === "premium")
			this.props.fetchServices()
		this.setState({ navigation: this.props.navigation })
	}

	componentDidUpdate(prevProps) {
		const elems = document.querySelectorAll('select:not(.browser-default)')
		M.FormSelect.init(elems)
		if (prevProps.pages !== this.props.pages)
			this.loadPage(true)
	}

	_initErrors = () => {
		const errors = {
			global: null,
			section: null,
			section_title: null,
			section_content: null,
			section_icon: null,
			section_phone: null,
			section_email: null,
			section_website: null,
			section_localisation: null,
			section_facebook: null,
			section_instagram: null,
			service: null,
			service_title: null,
			service_select: null,
			service_link: null
		}
		return errors
	}

	_initSuccess = () => {
		const success = {
			global: null,
			section: null,
			service: null
		}
		return success
	}

	setErrorMsg = (key, msg, id = null) => {
		if (key === "error_create_section")
		{
			key = "section"
			msg = tools.default_error_msg("Impossible de créer une section", msg)
		}
		else if (key === "error_update_section")
		{
			key = "section"
			msg = tools.default_error_msg("Impossible de modifier une section", msg)
		}
		else if (key === "error_delete_section")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de supprimer une section", msg)
		}
		else if (key === "error_update_service")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible d'ajouter un service", msg)
		}
		else if (key === "error_delete_service")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de supprimer un service", msg)
		}
		else if (key === "error_update_cover")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de mettre à jour une photo de couverture", msg)
		}
		else if (key === "error_order")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de réordonner les sections", msg)
		}
		else if (key === "error_duplicate")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de dupliquer une section", msg)
		}
		else if (key === "error_fetch_page")
		{
			key = "global"
			msg = tools.default_error_msg("Impossible de récupérer la page", msg)
		}
		let error = this._initErrors()
		if (id !== null)
			error[key][id] = msg
		else
			error[key] = msg
		this.setState({ success: this._initSuccess(), error: error })
	}

	setSuccessMsg = (key, msg) => {
		let success = this._initSuccess()
		success[key] = msg
		this.setState({ error: this._initErrors(), success: success })
	}

	clearFlash = () => {
		this.setState({ error: this._initErrors(), success: this._initSuccess() })
	}

	loadPage = (fromProps = false) => {
		if (fromProps === true && this.props.pages && this.state.page)
		{
			let page = null
			let form1 = {
				cover: null
			}
			let form3 = {
				add_service: false,
				service: '',
				link: '',
				translations: []
			}
			for (let i = 0; i < this.props.pages.length; i++)
			{
				if (this.props.pages[i]._id === this.state.page._id)
				{
					page = this.props.pages[i]
					for (let j = 0; j < page.sections.length; j++)
					{
						for (let k = 0; k < this.props.icons.length; k++)
						{
							if (page.sections[j].icon === this.props.icons[k]._id)
							{
								for (let l = 0; l < this.props.icons[k].fill.length; l++)
								{
									if (this.props.icons[k].fill[l].theme === this.props.theme._id)
									{
										page.sections[j].prev = this.props.icons[k].fill[l].icon
										break
									}
								}
								break
							}
						}
					}
					form1 = {
						cover: page.cover
					}
					if (page.service)
					{
						form3 = {
							add_service: true,
							service: page.service.service,
							link: page.service.link,
							translations: page.service.translations
						}
					}
					break
				}
			}
			this.setState({ page: page, form1: form1, form3: form3 })
		}
		else if (this.props.category)
		{
			const category = this.props.category._id
			this.props.fetchPageByCategory(category)
			.then(page => {
				for (let j = 0; j < page.sections.length; j++)
				{
					for (let k = 0; k < this.props.icons.length; k++)
					{
						if (page.sections[j].icon === this.props.icons[k]._id)
						{
							for (let l = 0; l < this.props.icons[k].fill.length; l++)
							{
								if (this.props.icons[k].fill[l].theme === this.props.theme._id)
								{
									page.sections[j].prev = this.props.icons[k].fill[l].icon
									break
								}
							}
							break
						}
					}
				}
				const form1 = {
					cover: page.cover
				}
				let form3 = {
					add_service: false,
					service: '',
					link: '',
					translations: []
				}
				if (page.service)
				{
					form3 = {
						add_service: true,
						service: page.service.service,
						link: page.service.link,
						translations: page.service.translations
					}
				}
				this.setState({ page: page, form1: form1, form3: form3 })
			})
			.catch(err => {
				this.setErrorMsg("error_fetch_page", 1)
				console.log(err)
			})
		}
		else if (this.props.page)
		{
			const page = this.props.page
			this.props.fetchPageByID(page)
			.then(page => {
				if (page.sections)
				{
					for (let j = 0; j < page.sections.length; j++)
					{
						for (let k = 0; k < this.props.icons.length; k++)
						{
							if (page.sections[j].icon === this.props.icons[k]._id)
							{
								for (let l = 0; l < this.props.icons[k].fill.length; l++)
								{
									if (this.props.icons[k].fill[l].theme === this.props.theme._id)
									{
										page.sections[j].prev = this.props.icons[k].fill[l].icon
										break
									}
								}
								break
							}
						}
					}
				}
				const form1 = {
					cover: page.cover
				}
				let form3 = {
					add_service: false,
					service: '',
					translations: []
				}
				if (page.service)
				{
					form3 = {
						add_service: true,
						service: page.service.service,
						translations: page.service.translations
					}
				}
				this.setState({ page: page, form1: form1, form3: form3 })
			})
			.catch(err => {
				this.setErrorMsg("error_fetch_page", 2)
				console.log(err)
			})
		}
	}

	handleTitle = (event) => {
		let found = false
		const translations = this.state.form2.translations
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.props.current_lang)
			{
				found = true
				translations[i].title = event.target.value
				break
			}
		}
		if (!found)
		{
			translations.push({
				lang: this.props.current_lang,
				title: event.target.value,
				html: ""
			})
		}
		const form2 = {
			...this.state.form2,
			translations: translations
		}
		this.setState({ form2: form2 })
	}

	handleIcon = (icon) => {
		const icons = this.props.icons
		let prev = null
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon)
			{
				for (let j = 0; j < icons[i].fill.length; j++)
				{
					if (icons[i].fill[j].theme === this.props.theme._id)
					{
						prev = icons[i].fill[j].icon
						break
					}
				}
				break
			}
		}
		const form2 = {
			...this.state.form2,
			icon: icon,
			prev: prev
		}
		this.setState({ form2: form2 })
	}

	handleHTML = (html) => {
		let found = false
		const translations = this.state.form2.translations
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.props.current_lang)
			{
				found = true
				translations[i].html = html
				break
			}
		}
		if (!found)
		{
			translations.push({
				lang: this.props.current_lang,
				title: "",
				html: html
			})
		}
		const form2 = {
			...this.state.form2,
			translations: translations
		}
		this.setState({ form2: form2 })
	}

	handlePhone = (event) => {
		const form2 = {
			...this.state.form2,
			phone: event.target.value
		}
		this.setState({ form2: form2 })
	}

	handleEmail = (event) => {
		const form2 = {
			...this.state.form2,
			email: event.target.value
		}
		this.setState({ form2: form2 })
	}

	handleWebsite = (event) => {
		const form2 = {
			...this.state.form2,
			website: event.target.value
		}
		this.setState({ form2: form2 })
	}

	handleLocalisation = (event) => {
		const form2 = {
			...this.state.form2,
			localisation: event.target.value
		}
		this.setState({ form2: form2 })
	}

	handleFacebook = (event) => {
		const form2 = {
			...this.state.form2,
			facebook: event.target.value
		}
		this.setState({ form2: form2 })
	}

	handleInstagram = (event) => {
		const form2 = {
			...this.state.form2,
			instagram: event.target.value
		}
		this.setState({ form2: form2 })
	}

	_validateForm2 = () => {
		let error_obj = this._initErrors()
		let error = false
		const phone = this.state.form2.phone.trim()
		const email = this.state.form2.email.trim()
		const website = this.state.form2.website.trim()
		const localisation = this.state.form2.localisation.trim()
		const facebook = this.state.form2.facebook.trim()
		const instagram = this.state.form2.instagram.trim()
		const translations = this.state.form2.translations
		let found_default_html = false
		let found_default_title = false
		for (let i = 0; i < translations.length; i++)
		{
			const lang = translations[i].lang
			const title = translations[i].title
			if (title.length === 0 && lang === this.props.lang_default)
			{
				error = true
				error_obj.section_title = "Vous devez indiquer le titre (version " + lang.toUpperCase() + ")"
			}
			else if (title.length > this.section_length_max)
			{
				error = true
				error_obj.section_title = "Le titre ne doit pas dépasser " + this.section_length_max + " caractères (version " + lang.toUpperCase() + ")"
			}
			else if (lang === this.props.lang_default)
				found_default_title = true
			const html = translations[i].html
			if (html.length === 0 && lang === this.props.lang_default)
			{
				error = true
				error_obj.section_content = "Vous devez insérer un contenu (version " + lang.toUpperCase() + ")"
			}
			else if (lang === this.props.lang_default)
				found_default_html = true
		}
		if (!found_default_title && !error_obj.section_title)
		{
			error = true
			error_obj.section_title = 'Vous devez indiquer le titre (version ' + this.props.lang_default.toUpperCase() + ')'
		}
		if (!found_default_html && !error_obj.section_content)
		{
			error = true
			error_obj.section_content = 'Vous devez insérer un contenu (version ' + this.props.lang_default.toUpperCase() + ')'
		}
		if (phone.length > 0 && /^\+?[0-9 ./-]{9,}$/.test(phone) === false)
		{
			error = true
			error_obj.section_phone = 'Le format du numéro de téléhpone n\'est pas correct'
		}
		if (email.length > 0 && /^[^@]+@.{2,}\.[a-z]{2,}$/.test(email) === false)
		{
			error = true
			error_obj.section_email = 'Le format de l\'e-mail n\'est pas correct'
		}
		if (website.length > 0 && /[^.]{2,}\.[a-z]{2,}/.test(website) === false)
		{
			error = true
			error_obj.section_website = 'Le format du site web n\'est pas correct'
		}
		if (localisation.length > 0 && /^https:\/\/goo\.gl\/maps\//.test(localisation) === false && /^https:\/\/www\.google\.[a-z]{2,}\/maps\//.test(localisation) === false)
		{
			error = true
			error_obj.section_localisation = 'Le format du lien Google Maps n\'est pas correct'
		}
		if (facebook.length > 0 && /^https:\/\/([a-z]{2,}\.)?facebook\.com\//.test(facebook) === false)
		{
			error = true
			error_obj.section_facebook = 'Le format du lien Facebook n\'est pas correct'
		}
		if (instagram.length > 0 && /^https:\/\/(www\.)?instagram\.com\//.test(instagram) === false)
		{
			error = true
			error_obj.section_instagram = 'Le format du lien Instagram n\'est pas correct'
		}
		if (error === true)
		{
			error_obj.section = "Il y a une ou plusieurs erreur(s) dans le formulaire"
			const success = this._initSuccess()
			this.setState({ success: success, error: error_obj, attempt_submit: false })
		}
		return (!error) ? true : false
	}

	submitSection = (event) => {
		event.preventDefault()
		this.setState({ attempt_submit: true })
		if (this._validateForm2())
		{
			const translations = this.state.form2.translations
			let langs_not_found = []
			for (let i = 0; i < this.props.langs.length; i++)
			{
				let found = false
				for (let j = 0; j < translations.length; j++)
				{
					if (this.props.langs[i] === translations[j].lang && translations[j].title.length > 0 && translations[j].html.length > 0)
					{
						found = true
						break
					}
				}
				if (!found)
					langs_not_found.push(this.props.langs[i])
			}
			if (langs_not_found.length > 0)
			{
				let msg = ""
				for (let i = 0; i < langs_not_found.length; i++)
				{
					if (i > 0)
						msg += ', '
					msg += langs_not_found[i].toUpperCase()
				}
				msg = "La page n'est pas traduite dans les langues suivantes : " + msg
				this.setState({ modal_msg: msg, open_modal: true, answerModal: this.answerModalEdit })
			}
			else
				this._insertPageSection()
		}
	}

	_insertPageSection = () => {
		const icon = this.state.form2.icon
		let phone = this.state.form2.phone.trim()
		let loop = true
		while (loop)
		{
			loop = false
			let newphone = phone.replace(/[/ .-]/, '')
			if (newphone.localeCompare(phone) !== 0)
				loop = true
			phone = newphone
		}
		const email = this.state.form2.email.trim()
		let website = this.state.form2.website.trim()
		if (website.length > 0 && /^http(s)?:\/\//.test(website) === false)
			website = "https://" + website
		const localisation = this.state.form2.localisation.trim()
		const facebook = this.state.form2.facebook.trim()
		const instagram = this.state.form2.instagram.trim()
		const translations = this.state.form2.translations
		if (this.state.section !== null)
		{
			let key = 0
			for (let i = 0; i < this.state.page.sections.length; i++)
			{
				if (this.state.page.sections[i] === this.state.section)
				{
					key = i
					break
				}
			}
			const section = {
				page_id: this.state.page._id,
				icon: icon,
				key: key,
				phone: phone,
				email: email,
				website: website,
				localisation: localisation,
				facebook: facebook,
				instagram: instagram,
				translations: translations
			}
			this.props.updatePageSection(section)
			.then(ret => {
				if (ret === false)
				{
					this.setState({ attempt_submit: false, open_modal: false })
					this.setErrorMsg("error_update_section", 1)
				}
				else
				{
					const form2 = {
						icon: null,
						prev: null,
						phone: '',
						email: '',
						website: '',
						localisation: '',
						facebook: '',
						instagram: '',
						translations: []
					}
					this.setState({ form2: form2, edit: false, attempt_submit: false, open_modal: false })
					this.setSuccessMsg("section", "La section a été mise à jour")
				}
			})
			.catch(err => {
				this.setState({ attempt_submit: false, open_modal: false })
				this.setErrorMsg("error_update_section", 2)
				console.log(err)
			})
		}
		else
		{
			const section = {
				page_id: this.state.page._id,
				icon: icon,
				phone: phone,
				email: email,
				website: website,
				localisation: localisation,
				facebook: facebook,
				instagram: instagram,
				translations: translations
			}
			this.props.insertPageSection(section)
			.then(ret => {
				if (ret === false)
				{
					this.setState({ attempt_submit: false, open_modal: false })
					this.setErrorMsg("error_create_section", 1)
				}
				else
				{
					const form2 = {
						icon: null,
						prev: null,
						phone: '',
						email: '',
						website: '',
						localisation: '',
						facebook: '',
						instagram: '',
						translations: []
					}
					this.setState({ form2: form2, edit: false, attempt_submit: false, open_modal: false })
					this.setSuccessMsg("section", "La section a été bien été créée")
				}
			})
			.catch(err => {
				this.setState({ attempt_submit: false, open_modal: false })
				this.setErrorMsg("error_create_section", 2)
				console.log(err)
			})
		}
	}

	handleCover = (event) => {
		const file = event.target.files[0]
		if (!file)
			return ;
		//réduction canvas avant envoi : 1600px max, jamais agrandie
		tools.resizeImageInfo(file, 1600, 1600, 0.85)
		.then(ret => {
			const form1 = {
				cover: ret.data
			}
			const warning = (ret.width < 800) ? "Cette image est petite (" + ret.width + " px de large), elle risque d'être floue en couverture" : null
			this.setState({ form1: form1, cover_warning: warning })
		})
		.catch(err => {
			this.setState({ cover_warning: err })
		})
	}

	submitCover = (event) => {
		event.preventDefault()
		// form1.cover ne vaut jamais l'ancienne photo (base64 vidée par extract_content_pictures.js
		// une fois en cache disque) : sans nouveau fichier choisi, il n'y a rien à envoyer, et
		// envoyer quand même écraserait/viderait la photo existante côté serveur.
		if (!this.state.form1.cover)
		{
			this.setState({ cover_warning: "Veuillez sélectionner une photo avant d'enregistrer" })
			return ;
		}
		this.setState({ attempt_submit: true })
		const page = {
			_id: this.state.page._id,
			cover: this.state.form1.cover
		}
		this.props.updatePageCover(page)
		.then(ret => {
			if (ret === false)
			{
				this.setState({ attempt_submit: false })
				this.setErrorMsg("error_update_cover", 1)
			}
			else
			{
				const form1 = {
					cover: null
				}
				this.setState({ form1: form1, update_cover: false, attempt_submit: false, cover_warning: null })
				this.setSuccessMsg("global", "La photo de couverture à été mise à jour")
			}
		})
		.catch(err => {
			this.setState({ attempt_submit: false })
			this.setErrorMsg("error_update_cover", 2)
			console.log(err)
		})
	}

	displayService = () => {
		const form3 = {
			...this.state.form3,
			add_service: (this.state.form3.add_service === true) ? false : true
		}
		this.setState({ form3: form3 })
	}

	handleService = (event) => {
		const form3 = {
			...this.state.form3,
			service: event.target.value
		}
		this.setState({ form3: form3 })
	}

	handleServiceTitle = (event) => {
		let found = false
		const translations = this.state.form3.translations
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.props.current_lang)
			{
				found = true
				translations[i].title = event.target.value
				break
			}
		}
		if (!found)
		{
			translations.push({
				lang: this.props.current_lang,
				title: event.target.value
			})
		}
		const form3 = {
			...this.state.form3,
			translations: translations
		}
		this.setState({ form3: form3 })
	}

	handleServiceLink = (event) => {
		const form3 = {
			...this.state.form3,
			link: event.target.value
		}
		this.setState({ form3: form3 })
	}

	_validateForm3 = () => {
		let error_obj = this._initErrors()
		let error = false
		const service = this.state.form3.service
		const link = this.state.form3.link
		const translations = this.state.form3.translations
		if ((!service || service.length === 0) && (!link || link.length === 0))
		{
			error = true
			error_obj.service = "Vous devez sélectionner un service ou renseigner un lien externe"
		}
		else if (service && service.length > 0 && link && link.length > 0)
		{
			error = true
			error_obj.service = "Vous devez choisir entre un service ou renseigner un lien externe"
		}
		let found_default_title = false
		for (let i = 0; i < translations.length; i++)
		{
			const lang = translations[i].lang
			const title = translations[i].title
			if (title.length === 0 && lang === this.props.lang_default)
			{
				error = true
				error_obj.service_title = "Vous devez indiquer le titre (version " + lang.toUpperCase() + ")"
			}
			else if (title.length > this.length_max)
			{
				error = true
				error_obj.service_title = "Le titre ne doit pas dépasser " + this.length_max + " caractères (version " + lang.toUpperCase() + ")"
			}
			else if (lang === this.props.lang_default)
				found_default_title = true
		}
		if (!found_default_title && !error_obj.service_title)
		{
			error = true
			error_obj.service_title = 'Vous devez indiquer le titre (version ' + this.props.lang_default.toUpperCase() + ')'
		}
		if (error === true)
		{
			if (!error_obj.service)
				error_obj.service = "Il y a une ou plusieurs erreur(s) dans le formulaire"
			const success = this._initSuccess()
			this.setState({ success: success, error: error_obj, attempt_submit: false })
		}
		return (!error) ? true : false
	}

	handleBreadcrumb = () => {
		/* par défaut ce que je récupère en props : vue catégorie
		1. Vue liste 
			-> Vue liste 
				-> Vue page
					-> Vue section

		2. Vue page
			-> vue section
		*/
	} 

	submitService = (event) => {
		event.preventDefault()
		this.setState({ attempt_submit: true })
		if (this.state.form3.add_service === true && this._validateForm3())
		{
			const translations = this.state.form3.translations
			let langs_not_found = []
			for (let i = 0; i < this.props.langs.length; i++)
			{
				let found = false
				for (let j = 0; j < translations.length; j++)
				{
					if (this.props.langs[i] === translations[j].lang && translations[j].title.length > 0)
					{
						found = true
						break
					}
				}
				if (!found)
					langs_not_found.push(this.props.langs[i])
			}
			if (langs_not_found.length > 0)
			{
				let msg = ""
				for (let i = 0; i < langs_not_found.length; i++)
				{
					if (i > 0)
						msg += ', '
					msg += langs_not_found[i].toUpperCase()
				}
				msg = "Le lien vers le service n'est pas traduite dans les langues suivantes : " + msg
				this.setState({ modal_msg: msg, open_modal: true, answerModal: this.answerModalService })
			}
			else
				this._insertPageService()
		}
		else if (this.state.form3.add_service === false)
		{
			const service = {
				page_id: this.state.page._id
			}
			this.props.deletePageService(service)
			.then(ret => {
				if (ret)
					this.setSuccessMsg("service", "Le service a bien été retiré de la page")
				else
					this.setErrorMsg("error_delete_service", 1)
				this.setState({ attempt_submit: false })
			})
			.catch(err => {
				this.setState({ attempt_submit: false })
				this.setErrorMsg("error_delete_service", 2)
				console.log(err)
			})
		}
	}

	_insertPageService = () => {
		const service = {
			page_id: this.state.page._id,
			service: this.state.form3.service,
			link: this.state.form3.link,
			translations: this.state.form3.translations
		}
		this.props.updatePageService(service)
		.then(ret => {
			if (!ret)
				this.setErrorMsg("error_update_service", 1)
			else
				this.setSuccessMsg("service", "Le service a bien été ajouté dans la page")
			this.setState({ attempt_submit: false, open_modal: false })
		})
		.catch(err => {
			this.setState({ attempt_submit: false, open_modal: false })
			this.setErrorMsg("error_update_service", 2)
			console.log(err)
		})
	}

	clickCreate = () => {
		const form2 = {
			icon: null,
			prev: null,
			phone: '',
			email: '',
			website: '',
			localisation: '',
			facebook: '',
			instagram: '',
			translations: []
		}
		this.clearFlash()
		this.setState({ form2: form2, section: null, edit: true, contacts_open: false })
	}

	clickSelect = (key) => {
		const section = this.state.page.sections[key]
		const form2 = {
			icon: section.icon,
			prev: section.prev,
			phone: (section.phone) ? section.phone : '',
			email: (section.email) ? section.email : '',
			website: (section.website) ? section.website : '',
			localisation: (section.localisation) ? section.localisation : '',
			facebook: (section.facebook) ? section.facebook : '',
			instagram: (section.instagram) ? section.instagram : '',
			translations: tools.clone(section.translations)
		}
		const contacts_open = (form2.phone.length > 0 || form2.email.length > 0 || form2.website.length > 0 || form2.localisation.length > 0 || form2.facebook.length > 0 || form2.instagram.length > 0)
		this.clearFlash()
		this.setState({ edit: true, section: section, form2: form2, contacts_open: contacts_open })
	}

	clickUp = (key) => {
		let update = false
		let sections = this.state.page.sections
		if (key > 0)
		{
			let order_tmp = sections[key - 1].order
			sections[key - 1].order = sections[key].order
			sections[key].order = order_tmp
			let section_tmp = sections[key - 1]
			sections[key - 1] = sections[key]
			sections[key] = section_tmp
			update = true
		}
		if (update === true)
		{
			const page = {
				_id: this.state.page._id,
				sections: sections
			}
			this.props.updatePageOrderSections(page)
			.then(ret => {
				if (ret === false)
					this.setErrorMsg("error_order", 1)
			})
			.catch(err => {
				this.setErrorMsg("error_order", 2)
				console.log(err)
			})
		}
	}

	clickDown = (key) => {
		let update = false
		let sections = this.state.page.sections
		if (key + 1 < sections.length)
		{
			let order_tmp = sections[key + 1].order
			sections[key + 1].order = sections[key].order
			sections[key].order = order_tmp
			let section_tmp = sections[key + 1]
			sections[key + 1] = sections[key]
			sections[key] = section_tmp
			update = true
		}
		if (update === true)
		{
			const page = {
				_id: this.state.page._id,
				sections: sections
			}
			this.props.updatePageOrderSections(page)
			.then(ret => {
				if (ret === false)
					this.setErrorMsg("error_order", 3)
			})
			.catch(err => {
				this.setErrorMsg("error_order", 4)
				console.log(err)
			})
		}
	}

	// clickMove = (key) => {
	// 	console.log("click move", key)
	// 	// const msg = "Vous allez dupliquer cette section et tout le contenu qui s'y trouve."
	// 	// this.setState({ duplicate: key, modal_msg: msg, open_modal: true, answerModal: this.answerModalDuplicate })
	// }

	clickDuplicate = (key) => {
		const msg = "Vous allez dupliquer cette section et tout le contenu qui s'y trouve."
		this.setState({ duplicate: key, modal_msg: msg, open_modal: true, answerModal: this.answerModalDuplicate })
	}

	_duplicateSection = () => {
		const section = {
			page_id: this.state.page._id,
			key: this.state.duplicate
		}
		this.props.updatePageDuplicateSection(section)
		.then(ret => {
			if (ret === false)
			{
				this.setState({ duplicate: false, open_modal: false })
				this.setErrorMsg("error_duplicate", 1)
			}
			else
			{
				this.setState({ duplicate: false, open_modal: false })
				this.setSuccessMsg("global", "La section a bien été dupliquée")
			}
		})
		.catch(err => {
			this.setState({ duplicate: false, open_modal: false })
			this.setErrorMsg("error_duplicate", 2)
			console.log(err)
		})
	}

	clickDelete = (key) => {
		const msg = "Vous supprimerez cette section et tout le contenu qui s'y trouve. Cette action est irréversible"
		this.setState({ delete: key, modal_msg: msg, open_modal: true, answerModal: this.answerModalDelete })
	}

	_deletePageSection = () => {
		const section = {
			page_id: this.state.page._id,
			key: this.state.delete
		}
		this.props.deletePageSection(section)
		.then(ret => {
			if (ret === false)
			{
				this.setState({ open_modal: false })
				this.setErrorMsg("error_delete_section", 1)
			}
			else
			{
				this.setState({ open_modal: false })
				this.setSuccessMsg("global", "La section a bien été supprimée")
			}
		})
		.catch(err => {
			this.setState({ open_modal: false })
			this.setErrorMsg("error_delete_section", 2)
			console.log(err)
		})
	}

	clickCover = () => {
		const update_cover = (this.state.update_cover === true) ? false : true
		this.setState({ update_cover: update_cover })
	}

	answerModalEdit = (answer) => {
		if (answer === "yes")
			this._insertPageSection()
		else
			this.setState({ attempt_submit: false, open_modal: false })
	}

	answerModalDelete = (answer) => {
		if (answer === "yes")
			this._deletePageSection()
		else
			this.setState({ delete: false, open_modal: false })
	}

	answerModalDuplicate = (answer) => {
		if (answer === "yes")
			this._duplicateSection()
		else
			this.setState({ duplicate: false, open_modal: false })
	}

	answerModalService = (answer) => {
		if (answer === "yes")
			this._insertPageService()
		else
			this.setState({ attempt_submit: false, open_modal: false })
	}

	unEdit = () => {
		this.setState({ edit: false })
	}

	toggleContacts = () => {
		this.setState({ contacts_open: (this.state.contacts_open === true) ? false : true })
	}

	// Nombre de coordonnées renseignées dans le formulaire de section
	_contactsCount = () => {
		const form2 = this.state.form2
		let count = 0
		const fields = ['phone', 'email', 'website', 'localisation', 'facebook', 'instagram']
		for (let i = 0; i < fields.length; i++)
		{
			if (form2[fields[i]] && form2[fields[i]].length > 0)
				count++
		}
		return count
	}

	// Résumé des coordonnées d'une section pour la ligne de description
	_sectionMeta = (section) => {
		let icons = []
		if (section.phone)
			icons.push('📞')
		if (section.email)
			icons.push('✉️')
		if (section.website)
			icons.push('🌐')
		if (section.localisation)
			icons.push('📍')
		if (section.facebook || section.instagram)
			icons.push('👥')
		if (!icons.length)
			return "texte seul"
		return icons.join(' ') + " coordonnées renseignées"
	}

	render() {
		if (this.state.page === null)
		{
			return (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		else
		{
			let titleHeader = null
			if (this.props.page) // category > liste > page 
				titleHeader = (<h1><span className="uhover" onClick={this.props.unShowGroup}>Rubriques</span> > <span className="uhover" onClick={this.props.unShowCategory}>Catégories</span> > <span className="uhover" onClick={this.props.unShowList}>Liste</span> > Page</h1>)	
			else // category > page
				titleHeader = (<h1><span className="uhover" onClick={this.props.unShowGroup}>Rubriques</span> > <span className="uhover" onClick={this.props.unShowCategory}>Catégories</span> > Page</h1>)
			const page = this.state.page
			//aperçu : pendant l'édition d'une section, elle est remplacée par le brouillon du formulaire (form2)
			let preview_page = page
			if (this.state.edit === true && this.state.section !== null && page.sections)
			{
				let sections = []
				for (let i = 0; i < page.sections.length; i++)
				{
					if (page.sections[i] === this.state.section)
					{
						sections.push({
							...page.sections[i],
							icon: this.state.form2.icon,
							prev: this.state.form2.prev,
							phone: this.state.form2.phone,
							email: this.state.form2.email,
							website: this.state.form2.website,
							localisation: this.state.form2.localisation,
							facebook: this.state.form2.facebook,
							instagram: this.state.form2.instagram,
							translations: this.state.form2.translations
						})
					}
					else
						sections.push(page.sections[i])
				}
				preview_page = {
					...page,
					sections: sections
				}
			}
			let left = null
			if (this.state.edit === true)
			{
				let title = ""
				let html = ""
				for (let i = 0; i < this.state.form2.translations.length; i++)
				{
					if (this.state.form2.translations[i].lang === this.props.current_lang)
					{
						title = this.state.form2.translations[i].title
						html = this.state.form2.translations[i].html
						break
					}
				}
				let sendbtn = (
					<div className="flex justify-end items-center pt-4 mt-4 border-t border-gray-100">
						<button
							type="button"
							onClick={this.unEdit}
							className="text-sm font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-4 py-2 mr-2"
							style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
						>Annuler</button>
						<button
							type="submit"
							className="text-sm font-semibold text-white rounded-lg px-5 py-2"
							style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}
						>{(this.state.section !== null) ? "Enregistrer" : "Ajouter la section"}</button>
					</div>
				)
				if (this.state.attempt_submit === true)
				{
					sendbtn = (
						<div className="center">
							<Loader />
						</div>
					)
				}
				if (this.props.page) // category > liste > page > section
					titleHeader = (<h1><span className="uhover" onClick={this.props.unShowGroup}>Rubriques</span> > <span className="uhover" onClick={this.props.unShowCategory}>Catégories</span> > <span className="uhover" onClick={this.props.unShowList}>Liste</span> > <span className="uhover" onClick={this.unEdit}>Page</span> > Section</h1>)
				else // category > page > section
					titleHeader = (<h1><span className="uhover" onClick={this.props.unShowGroup}>Rubriques</span> > <span className="uhover" onClick={this.props.unShowCategory}>Catégories</span> > <span className="uhover" onClick={this.unEdit}>Page</span> > Section</h1>)
				const contact_error = (this.state.error.section_phone || this.state.error.section_email || this.state.error.section_website || this.state.error.section_localisation || this.state.error.section_facebook || this.state.error.section_instagram)
				const contacts_open = (this.state.contacts_open === true || contact_error)
				const contacts_count = this._contactsCount()
				const reference = tools.getTranslationValue(this.state.form2.translations, this.props.lang_default, 'title')
				left = (
					<div>
						<div className="bg-white rounded-2xl shadow border border-gray-200 px-5 py-5">
							<p className="success">{this.state.success.section}</p>
							<div className="mb-4">
								<LangPills
									langs={this.props.langs}
									translations={this.state.form2.translations}
									fields={['title', 'html']}
									current={this.props.current_lang}
									onSelect={this.props.updateLang}
								/>
							</div>
							<form onSubmit={this.submitSection}>
								<label>
									<p className="error">{this.state.error.section_title}</p>
									<p className="flex justify-between items-baseline flex-wrap">
										<span className="text-xs font-semibold text-gray-600">Titre ({this.props.current_lang.toUpperCase()}) :</span>
										{(this.props.current_lang !== this.props.lang_default && reference) &&
											<span className="text-xs text-gray-400">Référence {this.props.lang_default.toUpperCase()} : « {reference} »</span>
										}
									</p>
									<input className="input-modern w-full" type="text" value={title} onChange={this.handleTitle} />
								</label>
								<div className="label">
									<p className="error">{this.state.error.section_icon}</p>
									<p className="text-xs font-semibold text-gray-600 mb-1">Icône :</p>
									<div className="flex items-center">
										{(this.state.form2.prev !== null) &&
											<span className="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center mr-3 flex-shrink-0">
												<img src={this.state.form2.prev} className="w-6 h-6" alt="Icône actuelle" />
											</span>
										}
										<IconPicker type="fill" theme={this.props.theme._id} icons={this.props.icons} onChange={this.handleIcon} allowNone={true} />
									</div>
								</div>
								<p className="error">{this.state.error.section_content}</p>
								<p className="flex justify-between items-baseline flex-wrap mb-1">
									<span className="text-xs font-semibold text-gray-600">Contenu ({this.props.current_lang.toUpperCase()}) :</span>
									<span className="text-xs text-gray-400">l'aperçu à droite suit la frappe</span>
								</p>
								<CKEditor
									toolbar="rubrics"
									data={html}
									updateContent={this.handleHTML}
								/>
								<p className="error">{this.state.error.section}</p>
								<button
									type="button"
									onClick={this.toggleContacts}
									className="w-full flex items-center text-sm font-semibold text-indigo-600 border-2 border-dashed border-gray-200 rounded-xl px-4 py-2.5 mt-4"
									style={{ backgroundImage: 'none', backgroundColor: '#FBFBFE' }}
								>
									<span className="mr-2" aria-hidden="true">{(contacts_open) ? '▾' : '▸'}</span>
									Coordonnées de contact
									<span className="ml-auto text-xs font-medium text-gray-400">
										{(contacts_count > 0) ? contacts_count + " renseignée" + ((contacts_count > 1) ? "s" : "") : "aucune"}
									</span>
								</button>
								{contacts_open &&
									<div className="border border-gray-100 rounded-xl px-4 py-4 mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">
										<label className="block">
											<span className="block text-xs font-semibold text-gray-600 mb-1"><span role="img" aria-label="phone">📞</span> Téléphone</span>
											<input className="input-modern w-full" type="text" value={this.state.form2.phone} onChange={this.handlePhone} />
											{this.state.error.section_phone && <span className="block text-xs text-red-600 mt-1">{this.state.error.section_phone}</span>}
										</label>
										<label className="block">
											<span className="block text-xs font-semibold text-gray-600 mb-1"><span role="img" aria-label="envelop">✉️</span> E-mail</span>
											<input className="input-modern w-full" type="text" value={this.state.form2.email} onChange={this.handleEmail} />
											{this.state.error.section_email && <span className="block text-xs text-red-600 mt-1">{this.state.error.section_email}</span>}
										</label>
										<label className="block">
											<span className="block text-xs font-semibold text-gray-600 mb-1"><span role="img" aria-label="globe">🌐</span> Site Internet</span>
											<input className="input-modern w-full" type="text" value={this.state.form2.website} onChange={this.handleWebsite} />
											{this.state.error.section_website && <span className="block text-xs text-red-600 mt-1">{this.state.error.section_website}</span>}
										</label>
										<label className="block">
											<span className="block text-xs font-semibold text-gray-600 mb-1"><span role="img" aria-label="earth">🌎</span> Géolocalisation (lien Google Maps)</span>
											<input className="input-modern w-full" type="text" value={this.state.form2.localisation} onChange={this.handleLocalisation} />
											{this.state.error.section_localisation && <span className="block text-xs text-red-600 mt-1">{this.state.error.section_localisation}</span>}
										</label>
										<label className="block">
											<span className="block text-xs font-semibold text-gray-600 mb-1"><span role="img" aria-label="person">🧑</span> Facebook</span>
											<input className="input-modern w-full" type="text" value={this.state.form2.facebook} onChange={this.handleFacebook} />
											{this.state.error.section_facebook && <span className="block text-xs text-red-600 mt-1">{this.state.error.section_facebook}</span>}
										</label>
										<label className="block">
											<span className="block text-xs font-semibold text-gray-600 mb-1"><span role="img" aria-label="camera">📷</span> Instagram</span>
											<input className="input-modern w-full" type="text" value={this.state.form2.instagram} onChange={this.handleInstagram} />
											{this.state.error.section_instagram && <span className="block text-xs text-red-600 mt-1">{this.state.error.section_instagram}</span>}
										</label>
									</div>
								}
								{sendbtn}
							</form>
						</div>
					</div>
				)
			}
			else
			{
				const hasCover = Boolean(this.state.form1.cover) || Boolean(this.state.page && this.state.page.cover_ext)
				const coverPreviewUrl = this.state.form1.cover ||
					((this.state.page && this.state.page.cover_ext) ? connexion.connect.url + 'webapp/pages/cover?id=' + this.state.page._id : null)
				const coverStyle = (coverPreviewUrl) ?
					{ backgroundImage: 'url(' + coverPreviewUrl + ')', backgroundSize: 'cover', backgroundPosition: 'center' }
					:
					{ background: 'linear-gradient(115deg, #E5E7EB 0%, #D1D5DB 100%)' }
				let sendbtn = (
					<div className="mt-3">
						<button type="submit" className="text-sm font-semibold text-white rounded-lg px-4 py-2 mr-2" style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}>Enregistrer</button>
						<button type="button" onClick={this.clickCover} className="text-sm font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-4 py-2" style={{ backgroundImage: 'none', backgroundColor: '#fff' }}>Annuler</button>
					</div>
				)
				if (this.state.attempt_submit === true)
				{
					sendbtn = (
						<div className="center">
							<Loader />
						</div>
					)
				}
				const formCover = (
					<div>
						<div className="relative rounded-2xl h-24 mb-3" style={{ ...coverStyle, boxShadow: '0 0 0 1px #E5E7EB' }}>
							<span className="absolute top-2 left-3 text-xs font-bold uppercase tracking-wide" style={{ color: (hasCover) ? 'rgba(255,255,255,0.9)' : '#9CA3AF', textShadow: (hasCover) ? '0 1px 2px rgba(0,0,0,0.4)' : 'none' }}>Photo de couverture</span>
							<button
								type="button"
								onClick={this.clickCover}
								className="absolute bottom-2 right-2 text-xs font-semibold text-gray-700 bg-white rounded-lg px-3 py-1.5 shadow"
								style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
							>{(hasCover) ? "Modifier la photo" : "Ajouter une photo"}</button>
						</div>
						{this.state.update_cover === true &&
							<div className="bg-white rounded-2xl shadow border border-gray-200 px-5 py-4 mb-3">
								<form onSubmit={this.submitCover}>
									<label>
										<p className="text-xs font-semibold text-gray-600 mb-1">Nouvelle photo :</p>
										<input type="file" accept="image/jpeg,image/png,image/webp" onChange={this.handleCover} />
									</label>
									{this.state.cover_warning && <p style={{ color: '#B45309', fontSize: '13px', margin: '4px 0 0' }}>{this.state.cover_warning}</p>}
									{sendbtn}
								</form>
							</div>
						}
					</div>
				)
				let services = null
				if (this.props.features === "premium")
				{
					let serviceForm = null
					if (this.state.form3.add_service === true)
					{
						const services_list = this.props.services
						const service_title = tools.getTranslationValue(this.state.form3.translations, this.props.current_lang, 'title')
						const service_reference = tools.getTranslationValue(this.state.form3.translations, this.props.lang_default, 'title')
						serviceForm = (
							<div className="border border-gray-100 rounded-xl px-4 py-4 mt-3">
								<div className="mb-3">
									<LangPills
										langs={this.props.langs}
										translations={this.state.form3.translations}
										fields={['title']}
										current={this.props.current_lang}
										onSelect={this.props.updateLang}
									/>
								</div>
								<label className="block mb-3">
									<span className="flex justify-between items-baseline flex-wrap">
										<span className="text-xs font-semibold text-gray-600 mb-1">Titre du bouton ({this.props.current_lang.toUpperCase()})</span>
										{(this.props.current_lang !== this.props.lang_default && service_reference) &&
											<span className="text-xs text-gray-400">Référence {this.props.lang_default.toUpperCase()} : « {service_reference} »</span>
										}
									</span>
									<input className="input-modern w-full" type="text" value={service_title} onChange={this.handleServiceTitle} />
									{this.state.error.service_title && <span className="block text-xs text-red-600 mt-1">{this.state.error.service_title}</span>}
								</label>
								<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
									<label className="block">
										<span className="block text-xs font-semibold text-gray-600 mb-1">Service</span>
										<select className="browser-default select-modern w-full" value={this.state.form3.service} onChange={this.handleService}>
											<option value="">-- Sélectionner un service --</option>
											<option value="precheckin">Pré-checkin</option>
											{services_list && services_list.map(({ _id, name }) => {
												return (<option value={_id} key={_id}>{name}</option>)
											})}
										</select>
										{this.state.error.service_select && <span className="block text-xs text-red-600 mt-1">{this.state.error.service_select}</span>}
									</label>
									<label className="block">
										<span className="block text-xs font-semibold text-gray-600 mb-1">ou lien externe (https://…)</span>
										<input className="input-modern w-full" type="text" value={this.state.form3.link} onChange={this.handleServiceLink} />
										{this.state.error.service_link && <span className="block text-xs text-red-600 mt-1">{this.state.error.service_link}</span>}
									</label>
								</div>
							</div>
						)
					}
					let sendbtn = (
						<div className="flex justify-end pt-4 mt-4 border-t border-gray-100">
							<button
								type="submit"
								className="text-sm font-semibold text-white rounded-lg px-5 py-2"
								style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}
							>Enregistrer</button>
						</div>
					)
					if (this.state.attempt_submit === true)
					{
						sendbtn = (
							<div className="center">
								<Loader />
							</div>
						)
					}
					services = (
						<div className="bg-white rounded-2xl shadow border border-gray-200 px-5 py-5 mt-4">
							<p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1">Bouton service (premium)</p>
							<p className="success">{this.state.success.service}</p>
							<form onSubmit={this.submitService}>
								<div className="flex items-center">
									<input id="service-toggle" className="checkbox-modern" type="checkbox" checked={this.state.form3.add_service} onChange={this.displayService} />
									<label htmlFor="service-toggle" className="text-sm font-semibold text-gray-700 ml-2 cursor-pointer">Afficher un bouton d'action sur cette page (réservation, pré-checkin, lien…)</label>
								</div>
								{serviceForm}
								{this.state.error.service && <p className="text-xs text-red-600 mt-2 mb-0">{this.state.error.service}</p>}
								{sendbtn}
							</form>
						</div>
					)
				}
				const sections = page.sections
				left = (
					<div>
						{formCover}
						<div className="flex items-center justify-between mb-2">
							<p className="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-0">Sections de la page</p>
							<span>
								<span className="text-xs text-gray-400 mr-2">Afficher en :</span>
								<LangPills langs={this.props.langs} current={this.props.current_lang} onSelect={this.props.updateLang} />
							</span>
						</div>
						<div className="bg-white rounded-2xl shadow border border-gray-200 divide-y divide-gray-100">
							{sections && sections.map((section, section_k) => {
								const title = tools.getTranslationValue(section.translations, this.props.current_lang, 'title')
								return (
									<div key={section_k} className="flex items-center px-4 py-3 hover:bg-gray-50 transition-colors group">
										<span className="w-4 text-right text-sm font-semibold text-gray-400 tabular-nums flex-shrink-0 mr-3">{section_k + 1}</span>
										<div className="w-9 h-9 rounded-lg bg-gray-100 flex-shrink-0 flex items-center justify-center mr-3">
											{(section.prev) ? <img src={section.prev} className="w-6 h-6" alt="" /> : <span className="text-gray-400 text-xs" aria-hidden="true">¶</span>}
										</div>
										<div className="flex-1 min-w-0 cursor-pointer" onClick={this.clickSelect.bind(this, section_k)}>
											<p className="text-base font-bold text-gray-900 truncate mb-0">{title}</p>
											<p className="text-xs text-gray-400 truncate mb-0 mt-0.5">{this._sectionMeta(section)}</p>
										</div>
										<span className="flex-shrink-0 ml-3 hidden sm:inline-flex">
											<LangPills langs={this.props.langs} translations={section.translations} fields={['title', 'html']} />
										</span>
										<div className="flex flex-col flex-shrink-0 ml-2">
											<button
												type="button"
												onClick={this.clickUp.bind(this, section_k)}
												disabled={section_k === 0}
												aria-label="Monter"
												className={"p-0.5 rounded leading-none " + ((section_k === 0) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
												style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
											>▲</button>
											<button
												type="button"
												onClick={this.clickDown.bind(this, section_k)}
												disabled={section_k === sections.length - 1}
												aria-label="Descendre"
												className={"p-0.5 rounded leading-none " + ((section_k === sections.length - 1) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
												style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
											>▼</button>
										</div>
										<button
											type="button"
											onClick={this.clickSelect.bind(this, section_k)}
											className="text-sm font-bold text-gray-600 group-hover:text-indigo-600 flex-shrink-0 ml-3 whitespace-nowrap"
											style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
										>Modifier ›</button>
										<Menu as="div" className="relative flex-shrink-0 ml-2">
											<Menu.Button
												className="w-8 h-8 rounded-lg border border-gray-200 text-gray-500 font-bold text-sm"
												style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
												aria-label="Plus d'actions"
											>⋯</Menu.Button>
											<Menu.Items className="absolute right-0 mt-1 w-40 bg-white rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10 py-1">
												<Menu.Item>
													{({ active }) => (
														<button
															type="button"
															onClick={this.clickDuplicate.bind(this, section_k)}
															className={"block w-full text-left px-4 py-2 text-sm text-gray-700 " + ((active) ? "bg-gray-100 focus:bg-gray-100" : "focus:bg-white")}
															style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none' }}
														>Dupliquer</button>
													)}
												</Menu.Item>
												<Menu.Item>
													{({ active }) => (
														<button
															type="button"
															onClick={this.clickDelete.bind(this, section_k)}
															className={"block w-full text-left px-4 py-2 text-sm text-red-600 " + ((active) ? "bg-red-50 focus:bg-red-50" : "focus:bg-white")}
															style={{ backgroundImage: 'none', border: 'none', boxShadow: 'none' }}
														>Supprimer…</button>
													)}
												</Menu.Item>
											</Menu.Items>
										</Menu>
									</div>
								)
							})}
							<div
								className="flex items-center justify-center px-4 py-3 cursor-pointer rounded-b-2xl"
								onClick={this.clickCreate}
								style={{ backgroundColor: '#FBFBFE' }}
							>
								<span className="inline-flex items-center text-sm font-semibold text-indigo-600 border-2 border-dashed border-indigo-200 rounded-lg px-4 py-2">
									<span className="mr-2" aria-hidden="true">+</span>Ajouter une section
								</span>
							</div>
						</div>
						{services}
					</div>
				)
			}
			// let breadcrumb = (
			// 	<nav className={navStyle} aria-label="Breadcrumb">
			// 		<ol className="bg-white rounded-md shadow px-6 flex space-x-4">
			// 			<li className="flex">
			// 				<div className="flex items-center">
			// 					<Link to="/" className="text-gray-400 hover:text-gray-500">
			// 						<HomeIcon className="flex-shrink-0 h-5 w-5" aria-hidden="true" />
			// 						<span className="sr-only">Home</span>
			// 					</Link>
			// 				</div>
			// 			</li>
			// 			{this.state.navigation.map((page) => {
			// 				if (this.props.page)
			// 				{
			// 					if (this.state.navigation.indexOf(page) === 1)
			// 						func = this.props.unShowGroup
			// 					else if (this.state.navigation.indexOf(page) === 2)
			// 						func = this.props.unShowCategory
			// 					else if (this.state.navigation.indexOf(page) === 3)
			// 						func = this.props.unShowList
			// 				}
			// 				// const func = (this.state.navigation.indexOf(page) === 1) ? this.props.unShowCategory : this.unEdit
			// 				return (
			// 					<li key={page.name} className="flex">
			// 						<div className="flex items-center">
			// 							<svg
			// 								className="flex-shrink-0 w-6 h-full text-gray-200"
			// 								viewBox="0 0 24 44"
			// 								preserveAspectRatio="none"
			// 								fill="currentColor"
			// 								xmlns="http://www.w3.org/2000/svg"
			// 								aria-hidden="true"
			// 							>
			// 								<path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
			// 							</svg>
			// 							<button
			// 								onClick={func.bind(this, page)}
			// 								className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
			// 								aria-current={page.current ? 'page' : undefined}
			// 							>
			// 								{page.name}
			// 							</button>
			// 						</div>
			// 					</li>
			// 				)
			// 			})}
			// 		</ol>
			// 	</nav>
			// )
			return (
				<div className="wrapper-content">
					{(this.props.embedded === true) ? null : titleHeader}
					{/* {breadcrumb}	 */}
					<p className="center error">{this.state.error.global}</p>
					<p className="center success">{this.state.success.global}</p>
					<Modal
						dismissible={false}
						content={this.state.modal_msg}
						open_modal={this.state.open_modal}
						answerModal={this.state.answerModal}
					/>
					<div className="flex flex-wrap items-start">
						<div className="flex-1 mr-8" style={{ minWidth: '340px' }}>
							{left}
						</div>
						<div className="flex-shrink-0 mx-auto" style={{ width: '300px' }}>
							<p className="text-xs font-bold uppercase tracking-wide text-green-700 mb-2 flex items-center">
								<span className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" aria-hidden="true"></span>
								Aperçu en direct (vacancier)
							</p>
							<div className="rounded-3xl bg-gray-900 p-2 shadow-xl">
								<div className="w-10 h-1 rounded-full bg-gray-700 mx-auto mb-1.5" aria-hidden="true"></div>
								<div className="rounded-2xl bg-white" style={{ height: '600px', overflow: 'hidden' }}>
									{/* le rendu webapp fait 375px de large (RenderPage.css) : affiché à l'échelle 0,757 pour tenir dans les 284px du téléphone */}
									<div className="phone-preview" style={{ width: '375px', height: '792px', transform: 'scale(0.757)', transformOrigin: 'top left', overflowY: 'auto' }}>
										<RenderPage
											current_lang={this.props.current_lang}
											icons={this.props.icons}
											page={preview_page}
											theme={this.props.theme}
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
	}
}

export default Pages
